import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResponse } from 'src/app/invopay/interfaces/ip-page-response';
import { QueryParametersService } from 'src/app/invopay/services/ip-query-parameter.service';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import {
  FinConsolidatedItemResponse,
  FinConsolidatedResponse,
  FinPaymentDetailResponse,
} from '../model/fin-consolidated-response';
import { FinInvoiceResponse } from '../model/fin-invoice-response';
import {
  FinConsolidatedTemplateReq,
  FinConsolidatedTemplateResponse,
  FinCreatedConsolidatedResponse,
} from '../model/fin-consolidated-template-req';
import { IpPayInResponse } from 'src/app/invopay/interfaces/ip-pay-in-response';

export interface CurrentConsolidate{
  name:string | null;
  createdBy:string | null;
  modifiedBy:string | null;
  lastModificationDate:string | null;
}

@Injectable({
  providedIn: 'root',
})
export class FnConsolidatedService {
  api = environment.api;
  private _currentConsolidate: CurrentConsolidate = { name: null, createdBy: null, modifiedBy: null, lastModificationDate:null };  

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) {}

  getConsolidateDetails(
    consolidatedId: number
  ): Observable<PageResponse<FinConsolidatedItemResponse>> {
    return this.http.get<PageResponse<FinConsolidatedItemResponse>>(
      this.api + `/invopay/finances-business/consolidates/${consolidatedId}`
    );
  }

  sendStatusChange(consolidatedId: number, newStatus: string, paidDate: string, observation: string|null): Observable<any> {
    // Asegúrate de que el parámetro 'newStatus' se está configurando correctamente
    let params = new HttpParams().set('newStatus', newStatus);
    params = params.set('payDate', paidDate);
    if (observation) params = params.set('observation', observation);
    return this.http.put<PageResponse<FinConsolidatedResponse>>(
      this.api + `/invopay/finances-business/consolidates/${consolidatedId}`,
      null,
      { params }
    );
  }

  getConsolidateIdDetails(
    consolidatedId: number
  ): Observable<FinConsolidatedItemResponse> {
    return this.http.get<FinConsolidatedItemResponse>(
      this.api +
        `/invopay/finances-business/consolidates/${consolidatedId}/details`
    );
  }

  getConsolidates(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    businessName: string, 
    isPaid?: boolean
  ): Observable<PageResponse<FinConsolidatedResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );

    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (businessName && businessName.trim() !== '') {
      params = params.set('businessName', businessName);
    }
    if (isPaid != null) {
      params = params.set('isPaid', isPaid);
    }

    return this.http.get<PageResponse<FinConsolidatedResponse>>(
      this.api + '/invopay/finances-business/consolidates',
      { params }
    );
  }

  getInvoicesToPay(
    pagination: IPagination,
    startDate: string,
    endDate: string,
    businessName: string
  ): Observable<PageResponse<FinInvoiceResponse>> {
    let params = this.queryParameterService.buildQueryParameters(
      '',
      '',
      pagination,
      '',
      ''
    );

    if (startDate && startDate.trim() !== '') {
      params = params.set('startDate', startDate);
    }
    if (endDate && endDate.trim() !== '') {
      params = params.set('endDate', endDate);
    }
    if (businessName && businessName.trim() !== '') {
      params = params.set('businessName', businessName);
    }

    return this.http.get<PageResponse<FinInvoiceResponse>>(
      this.api + '/invopay/finances-business/invoices-to-pay',
      { params }
    );
  }

  sendInvoicesToConsolidatedTemplate(
    invoicesToConsolidated: any
  ): Observable<FinConsolidatedTemplateResponse> {
    return this.http.post<FinConsolidatedTemplateResponse>(
      this.api + '/invopay/finances-business/consolidated/template',
      invoicesToConsolidated
    );
  }

  generateConsolidated(
    consolidatedReq: FinConsolidatedTemplateResponse
  ): Observable<FinCreatedConsolidatedResponse> {
    return this.http.post<FinCreatedConsolidatedResponse>(
      this.api + '/invopay/finances-business/consolidated/create',
      consolidatedReq
    );
  }

  payConsolidatedItem(consolidatedItemId: number, isPaid:boolean, paidDate: string|null, observation: string|null): Observable<FinConsolidatedItemResponse> {
    let params = new HttpParams()
    params = params.set('isPaid', isPaid);
    if (paidDate) params = params.set('payDate', paidDate);
    if (observation) params = params.set('observation', observation);
    return this.http.post<FinConsolidatedItemResponse>(
      this.api + `/invopay/finances-business/consolidates/pay-item/${consolidatedItemId}`, 
      null,
      {params}
    )
  }

  public get currentConsolidate(): CurrentConsolidate {
    return this._currentConsolidate;
  }

  public set currentConsolidate(value: CurrentConsolidate) {
    this._currentConsolidate = value;
  }
}
